export default __webpack_public_path__ + "static/media/BSECAwardCertificate2021_page-0001.b0104ed8.jpg";